"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconMeasuredFilled = function IconMeasuredFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17 13V9.64C17.016 9.00168 16.7965 8.37981 16.3833 7.89293C15.9702 7.40605 15.3924 7.08821 14.76 7C14.4105 6.96345 14.0573 7.00098 13.7233 7.11015C13.3893 7.21931 13.0821 7.39766 12.8216 7.63355C12.5612 7.86945 12.3534 8.15759 12.2119 8.47919C12.0703 8.80079 11.9981 9.14862 12 9.5V13H9.64001C9.00169 12.9841 8.37982 13.2036 7.89294 13.6167C7.40606 14.0298 7.08822 14.6076 7.00001 15.24C6.96346 15.5895 7.00099 15.9427 7.11016 16.2767C7.21932 16.6107 7.39767 16.9179 7.63357 17.1784C7.86946 17.4388 8.1576 17.6466 8.4792 17.7881C8.8008 17.9297 9.14863 18.0019 9.50001 18H33V28.36C32.9841 28.9983 33.2036 29.6202 33.6167 30.1071C34.0298 30.594 34.6076 30.9118 35.24 31C35.5895 31.0365 35.9427 30.999 36.2767 30.8899C36.6107 30.7807 36.918 30.6023 37.1784 30.3664C37.4388 30.1306 37.6466 29.8424 37.7882 29.5208C37.9297 29.1992 38.0019 28.8514 38 28.5V14C38 13.7348 37.8947 13.4804 37.7071 13.2929C37.5196 13.1054 37.2652 13 37 13H17Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.36 33H17V22.64C17.016 22.0017 16.7965 21.3798 16.3833 20.8929C15.9702 20.406 15.3924 20.0882 14.76 20C14.4105 19.9635 14.0573 20.001 13.7233 20.1101C13.3893 20.2193 13.0821 20.3977 12.8216 20.6336C12.5612 20.8694 12.3534 21.1576 12.2119 21.4792C12.0703 21.8008 11.9981 22.1486 12 22.5V37C12 37.2652 12.1054 37.5196 12.2929 37.7071C12.4804 37.8946 12.7348 38 13 38H33V40.36C32.9841 40.9983 33.2036 41.6202 33.6167 42.1071C34.0298 42.594 34.6076 42.9118 35.24 43C35.5895 43.0365 35.9427 42.999 36.2767 42.8899C36.6107 42.7807 36.918 42.6023 37.1784 42.3664C37.4388 42.1305 37.6466 41.8424 37.7882 41.5208C37.9297 41.1992 38.0019 40.8514 38 40.5V38H40.5C40.8514 38.0019 41.1992 37.9297 41.5208 37.7881C41.8424 37.6466 42.1306 37.4388 42.3664 37.1784C42.6023 36.9179 42.7807 36.6107 42.8899 36.2767C42.999 35.9427 43.0366 35.5895 43 35.24C42.9118 34.6076 42.594 34.0298 42.1071 33.6167C41.6202 33.2036 40.9983 32.9841 40.36 33Z",
    fill: color
  }));
};

IconMeasuredFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconMeasuredFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconMeasuredFilled;
exports.default = _default;